<app-alert></app-alert>

<div class="row mt-2">
    <div class="form-group col mb-n1">
        <h1>Orders List</h1>
    </div>
</div>

<div class="card mb-3 mt-2 order-filter-card">
    <div class="card-body bg-light p-3">
        <div class="left">
            <div class="input-group input-group-sm w-lg-50 order-filter-card">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-secondary text-light">Filter</span>
                </div>
                <input class="form-control" placeholder="Search" type="text" autofocus="autofocus" (keyup)="tableFiltring($event)" />
            </div>
        </div>
        <div class="right">
            <div class="btn-group input-group-sm">
                <button type="button" class="btn btn-secondary btn-sm" [ngClass]="{ active: dateMode === 'today' }" (click)="toggleDateMode('today')">
                    Today
                </button>
                <button type="button" class="btn btn-secondary btn-sm" [ngClass]="{ active: dateMode === 'yesterday' }" (click)="toggleDateMode('yesterday')">
                    Yesterday
                </button>
                <div class="btn-group" ngbDropdown container="body" #myDrop="ngbDropdown">
                    <button type="button" class="btn btn-secondary btn-sm" ngbDropdownToggle></button>
                    <div class="dropdown-menu filter-content-dropdown" ngbDropdownMenu>
                        <div class="header">Order Date</div>
                        <div class="date">
                            <input
                                class="form-control input-datepicker-icon"
                                placeholder="dd/mm/yyyy"
                                name="dp"
                                [(ngModel)]="model"
                                ngbDatepicker
                                #d="ngbDatepicker"
                                (click)="d.toggle()"
                            />
                        </div>
                        <div class="btns">
                            <button type="button" class="btn btn-sm btn-secondary btn-sm" (click)="myDrop.close()">Close</button>
                            <button type="button" class="btn btn-sm btn-primary btn-sm" (click)="filterOrderByDate(); myDrop.close()">Filter Orders</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-datatable
    #table
    class="bootstrap-table table-hover row-cursor"
    [rows]="items"
    [headerHeight]="61"
    [footerHeight]="38"
    [rowHeight]="'auto'"
    [columnMode]="'standard'"
    [scrollbarH]="true"
>
    <ngx-datatable-column name="Order Id" prop="orderMasterId" [cellClass]="'tb-col-4'" [headerClass]="'tb-col-4'" [draggable]="false" [resizeable]="false">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>
                <span class="btn-as-link" (click)="openOrder(row)">
                    {{ value }}
                </span>
                <span class="badge badge-secondary table-badge" *ngIf="row.status === 'Placed'">
                    {{ row.status }}
                </span>
                <span class="badge badge-primary table-badge" *ngIf="row.status === 'Accepted'">
                    {{ row.status }}
                </span>
                <span class="badge badge-info table-badge" *ngIf="row.status === 'In Delivery'">
                    {{ row.status }}
                </span>
                <span class="badge badge-success table-badge" *ngIf="row.status === 'Delivered'">
                    {{ row.status }}
                </span>
                <span class="badge badge-danger table-badge" *ngIf="row.status === 'Canceled'">
                    {{ row.status }}
                </span>
            </div>
            <div class="cells-mobile">
                <div class="cell-value-line">{{ row.orderType === 'delivery' ? 'Delivery' : 'Reservation' }}</div>
                <div class="cell-value-line">{{ row.branchName }}</div>
                <div class="cell-value-line">{{ row.placedAt | date: 'MM/dd/yyyy, hh:mm a' }}</div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Type"
        prop="orderType"
        [cellClass]="'tb-col-4 mobile-hide'"
        [headerClass]="'tb-col-4 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value === 'delivery' ? 'Delivery' : 'Reservation' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Branch"
        prop="branchName"
        [cellClass]="'tb-col-4 mobile-hide'"
        [headerClass]="'tb-col-4 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Placed At"
        prop="placedAt"
        [cellClass]="'tb-col-4 mobile-hide'"
        [headerClass]="'tb-col-4 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value | date: 'MM/dd/yyyy, hh:mm a':'+0200' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        [cellClass]="'actions-cell tb-col-4'"
        [headerClass]="'actions-cell tb-col-4'"
        [draggable]="false"
        [resizeable]="false"
        [sortable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <ng-container *ngIf="accountService.currentUser.roles[0] === 'admin'">
                <div class="btn-group ml-2" ngbDropdown container="body">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle>Actions</button>
                    <div class="dropdown-menu" ngbDropdownMenu>
                        <a class="dropdown-item btn-sm" ngbDropdownItem (click)="openOrder(row)">View</a>
                        <div class="dropdown-divider" [hidden]="row.status === 'Delivered' || row.status === 'Canceled'"></div>
                        <a class="dropdown-item btn-sm" ngbDropdownItem (click)="confirmAccept(row)" *ngIf="row.status === 'Placed'">Accept</a>
                        <a class="dropdown-item btn-sm" ngbDropdownItem (click)="confirmInDelivery(row)" *ngIf="row.status === 'Accepted'">In Delivery</a>
                        <a class="dropdown-item btn-sm" ngbDropdownItem (click)="confirmCancel(row)" *ngIf="row.status === 'Placed'">Cancel</a>
                        <a class="dropdown-item btn-sm" ngbDropdownItem (click)="confirmDelivered(row)" *ngIf="row.status === 'In Delivery'">Delivered</a>
                    </div>
                </div>
            </ng-container>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-footer></ngx-datatable-footer>
</ngx-datatable>
